import { render, staticRenderFns } from "./PostDate.vue?vue&type=template&id=5b301a81&scoped=true"
import script from "./PostDate.vue?vue&type=script&lang=js"
export * from "./PostDate.vue?vue&type=script&lang=js"
import style0 from "./PostDate.vue?vue&type=style&index=0&id=5b301a81&prod&lang=scss"
import style1 from "./PostDate.vue?vue&type=style&index=1&id=5b301a81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b301a81",
  null
  
)

export default component.exports